import { useTranslation } from "../../../localization/useTranslation.ts";
import { DotLegalButton, DotLegalOverflowMenu, DotLegalPageHeader, ITableHeader } from "@dotlegal/dotlegal-ui-components";
import { ContractTypeViewModel } from "./ContractType.types.ts";
import { TableCell, TableRow } from "@mui/material";
import DotLegalDeleteDialogWrapper from "../../../common/components/dotLegalDeleteDialog/DotLegalDeleteDialogWrapper.tsx";
import useContractTypesHooks from "./ContractTypes.hooks.ts";
import AddEditContractTypeDialog from "../addEditContractTypeDialog/AddEditContractTypeDialog.tsx";
import { Box } from "@mui/system";
import DotLegalTableWithControlsLocalized from "../../../common/components/dotLegalTableWithControlsLocalized/DotLegalTableWithControlsLocalized.tsx";
import TablePagePaper from "@common/components/tablePagePaper/TablePagePaper";

function ContractTypes() {
    const { translateString } = useTranslation();
    const {
        contractTypes,
        isLoading,
        breadCrumbs,
        getMenuItems,
        onDialogClose,
        showCreateDialog,
        onSaved,
        contractTypeForDeletion,
        setContractTypeForDeletion,
        onDelete,
        onCreateClick,
        canManageMasterData,
        contractTypeForUpdate,
        isDeleting,
    } = useContractTypesHooks();

    const headers = Array<ITableHeader<ContractTypeViewModel>>();
    headers.push({ property: "name", text: translateString("name") });

    return (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <DotLegalPageHeader
                breadCrumbs={breadCrumbs}
                rightComponent={
                    canManageMasterData ? (
                        <DotLegalButton size="medium" buttonType={"primary"} onClick={() => onCreateClick()}>
                            {translateString("createContractType")}
                        </DotLegalButton>
                    ) : undefined
                }
            />
            <TablePagePaper>
                <DotLegalTableWithControlsLocalized
                    internalScroll
                    headers={headers}
                    isLoading={isLoading}
                    data={contractTypes}
                    emptyText={translateString("noContractTypes")}
                    defaultOrderBy={"name"}
                    getUserSpecificPageLength={() => 100}
                    clickableRows={false}
                    hasOverflowMenu
                    hideRowsPerPage={false}
                    renderRow={(row) => (
                        <TableRow key={row.id}>
                            <TableCell>{row.name}</TableCell>
                            <TableCell align={"right"}>
                                <DotLegalOverflowMenu items={getMenuItems(row)} />
                            </TableCell>
                        </TableRow>
                    )}
                />
            </TablePagePaper>
            {contractTypeForDeletion && (
                <DotLegalDeleteDialogWrapper
                    open
                    onDialogClose={() => setContractTypeForDeletion(undefined)}
                    onOkClick={onDelete}
                    itemForDeletion={contractTypeForDeletion.name}
                    inProgress={isDeleting}
                />
            )}
            {(showCreateDialog || contractTypeForUpdate !== undefined) && (
                <AddEditContractTypeDialog
                    onDialogClose={onDialogClose}
                    isAdd={contractTypeForUpdate === undefined}
                    ContractTypeToUpdate={contractTypeForUpdate}
                    onSaved={onSaved}
                />
            )}
        </Box>
    );
}

export default ContractTypes;
